import React, { useContext, useState, useEffect } from "react"
import { globalHistory } from "@reach/router"
import { StateContext } from "./provider"

import { motion, AnimatePresence } from "framer-motion"
//icons
import { CheckCircleIcon } from "@heroicons/react/20/solid"
import { XMarkIcon } from "@heroicons/react/20/solid"
import { ExclamationCircleIcon } from "@heroicons/react/20/solid"
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid"
import { InformationCircleIcon } from "@heroicons/react/20/solid"

//popup alert
const PageAlert = () => {
  //all the alerts of alerts
  const { stateAlert } = useContext(StateContext)
  const [pageAlert, setPageAlert] = stateAlert
  const [alertVisible, setAlertVisible] = useState(false)
  const [timerId, setTimerId] = useState()

  //remove alert
  const dismissAlert = () => {
    setAlertVisible(false)
    setPageAlert({})
    clearTimeout(timerId)
  }

  useEffect(() => {
    return globalHistory.listen(({ action }) => {
      action === "POP" && dismissAlert()
    })
  })

  useEffect(() => {
    const alertToggle = function () {
      const isVisible = alertVisible
      const isNew = Object.keys(pageAlert).length > 0 ? true : false
      const killAlert = () => {
        setAlertVisible(false)
        setPageAlert({})
      }
      const alertTimer = () => {
        setTimerId(setTimeout(() => killAlert(), 3000))
      }
      if (!isVisible && isNew) {
        setAlertVisible(isNew)
        if (!("halt" in pageAlert)) {
          alertTimer()
          return () => clearTimeout(timerId)
        }
      }
      if (isVisible && isNew) {
        clearTimeout(timerId)
        if (!("halt" in pageAlert)) {
          alertTimer()
        }
      }
    }
    alertToggle()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageAlert])

  //animation
  const alertVariants = {
    show: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 80,
        mass: 1,
        damping: 12,
        duration: 2,
      },
    },
    hide: {
      x: "100vw",
      opacity: 0,
    },
    exit: {
      x: ["-5vw", "100vw"],
      transition: { type: "tween", ease: "easeInOut", duration: 0.25 },
    },
  }

  return (
    <div className="pointer-events-none fixed inset-0 z-50 flex items-end justify-center space-y-3 px-4 py-6 sm:flex-col sm:items-end sm:justify-start sm:p-6">
      <AnimatePresence>
        {alertVisible && (
          <motion.div
            variants={alertVariants}
            initial="hide"
            animate="show"
            exit="exit"
            className="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg"
          >
            <div className="overflow-hidden rounded-lg ring-1 ring-black ring-opacity-5">
              <div className="p-3">
                <div className="flex items-center">
                  <div className="shrink-0">
                    {pageAlert.type === "warning" ? (
                      <ExclamationTriangleIcon className="h-6 w-6 text-amber-400" />
                    ) : (
                      ``
                    )}
                    {pageAlert.type === "error" ? (
                      <ExclamationCircleIcon className="h-6 w-6 fill-current text-rose-400" />
                    ) : (
                      ``
                    )}
                    {pageAlert.type === "success" ? (
                      <CheckCircleIcon className="h-6 w-6 fill-current text-emerald-400" />
                    ) : (
                      ``
                    )}
                    {pageAlert.type === "info" ? (
                      <InformationCircleIcon className="h-6 w-6 fill-current text-blue-400" />
                    ) : (
                      ``
                    )}
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-xs font-normal leading-5 text-slate-900">
                      {pageAlert.title}
                    </p>
                    <p className="text-xs leading-5 text-slate-500">
                      {pageAlert.message}
                    </p>
                  </div>
                  <div className="ml-4 flex shrink-0">
                    <button
                      aria-label="close"
                      className="inline-flex text-slate-400 transition focus:text-slate-500 focus:outline-none"
                      onClick={() => dismissAlert()}
                    >
                      <XMarkIcon className="h-5 w-5 stroke-current" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default PageAlert
